import { authenticatedFastApiAxiosInstance } from "@/lib/data/http";
import { type APIResponse, type MatterTag } from "@/lib/types";
import { baseFastApiMatterRoute } from "./matter";

export const createMatterTagV1 = (data: Partial<MatterTag>) => {
  return authenticatedFastApiAxiosInstance
    .post<APIResponse<MatterTag>>(`${baseFastApiMatterRoute}/tags`, data)
    .then((res) => res.data);
};

export const updateMatterTagV1 = (
  data: Pick<MatterTag, "id" | "dateModified"> & Partial<MatterTag>,
) => {
  return authenticatedFastApiAxiosInstance
    .patch<APIResponse<MatterTag>>(`${baseFastApiMatterRoute}/tags`, data)
    .then((res) => res.data);
};

export const deleteMatterTagV1 = (data: { id: string }) => {
  const { id } = data;
  return authenticatedFastApiAxiosInstance
    .delete<APIResponse<MatterTag>>(`${baseFastApiMatterRoute}/tags/${id}`)
    .then((res) => res.data);
};
